'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SecondaryButton = require('./components/SecondaryButton.component');

var _SecondaryButton2 = _interopRequireDefault(_SecondaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SecondaryButton2.default; /*
                                              * Exports
                                              */


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/secondary/index.js
// module id = 1050
// module chunks = 1